// Copyright: IQGeo Limited 2010-2022
import myw from 'myWorld/base/core';

/**
 * Extension of JavaScript's Error constructor that provides a simple way to define User exceptions. <br/>
 * Child User-defined exceptions mantain a prototype tree and therefore can be used with {@link https://github.com/petkaantonov/bluebird/blob/v2.9.7/API.md#catchfunction-errorclassfunction-predicate-function-handler---promise Bluebird's .catch ErrorClass mechanism}
 * @example var ExpiredRequestError = myw.Error.extend();
 * ...
 * throw new ExpiredRequestError('Too long...');
 * //> Uncaught > Object {message: "Too long...", (...)}
 * @example
 * //including the name of the exception as argument can provide better debugging as it will be used as the
 * //name of the constructor function
 * var ExpiredRequestError = myw.Error.extend('ExpiredRequestError');
 * throw new ExpiredRequestError();
 * //> Uncaught > ExpiredRequestError {message: undefined, name: "ExpiredRequestError", (...)}
 * @example //catching a specific User-defined exception
 * somePromise.then(function() {
 *     return a.b.c.d();
 * }).catch(ExpiredRequestError, function(e) {
 *     //will end up here if the thrown error was an instance of ExpiredRequestError
 * }).catch(function(e) {
 *     //unexpected error
 * })
 *
 * @name Error
 * @constructor
 */
myw.Error = function (message) {
    this.message = message;
    this.name = 'myw.Error';
    Error.captureStackTrace(this, myw.Error);
};
myw.Error.prototype = Object.create(Error.prototype);
myw.Error.prototype.constructor = myw.Error; //for stack traces
myw.Error.extend = function (name) {
    const constructor = function (message) {
        this.message = message || name;
        if (name) this.name = name;
        if (Error.captureStackTrace) Error.captureStackTrace(this, NewClass);
    };

    const NewClass = new Function(
        'action',
        `return function ${name || ''}(){ action.apply(this, arguments);}`
    )(constructor);

    NewClass.prototype = Object.create(this.prototype);
    NewClass.prototype.constructor = NewClass;
    NewClass.extend = this.extend;
    return NewClass;
};

myw.AuthenticationError = myw.Error.extend('AuthenticationError');
myw.NetworkError = myw.Error.extend('NetworkError');
myw.ObjectNotFoundError = myw.Error.extend('ObjectNotFoundError');
myw.UnauthorizedError = myw.Error.extend('UnauthorizedError');
myw.DuplicateKeyError = myw.Error.extend('DuplicateKeyError');
myw.BadRequest = myw.Error.extend('BadRequest');
myw.MissingImplementationError = myw.Error.extend('MissingImplementationError');
myw.MissingFeatureDD = myw.Error.extend('MissingFeatureDD');
myw.UnitNotDefinedError = myw.Error.extend('UnitNotDefinedError');
myw.ParseFloatError = myw.Error.extend('ParseFloatError');
myw.URLNotDefinedError = myw.Error.extend('URLNotDefinedError');
myw.TimeoutError = myw.Error.extend('TimeoutError');
myw.RequestTooLargeError = myw.Error.extend('RequestTooLargeError');
